import { render, staticRenderFns } from "./Modalv2.vue?vue&type=template&id=3e7e0e06&scoped=true"
import script from "./Modalv2.vue?vue&type=script&lang=ts"
export * from "./Modalv2.vue?vue&type=script&lang=ts"
import style0 from "./Modalv2.vue?vue&type=style&index=0&id=3e7e0e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e0e06",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WButton: require('/skade-pwa/components/ui/atom/WButton/WButton.vue').default,Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
